<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail">
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="防疫指挥部" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="name">
              <a-input v-model="model.name" placeholder="请输入防疫指挥部"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="选择厂区" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="factoryIds">
              <j-multi-select-tag
                @change="handleFactoryChange"
                type="select"
                v-model="model.factoryIds"
                :options="factoryOptions"
                allowClear
                >
              </j-multi-select-tag>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="系统账号" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="principalId">
              <a-select
                placeholder="请选择系统账号"
                v-model="model.principalId" :options="sysAccountOptions"
                @change="handleAccoutChange"
                allowClear></a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="负责人工号" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="employeeNo">
              <a-input v-model="model.employeeNo" placeholder="请输入负责人工号"  disabled></a-input>
            </a-form-model-item>
          </a-col>

          <a-col :span="12">
            <a-form-model-item label="负责人姓名" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="principalName">
              <a-input v-model="model.principalName" placeholder="请输入负责人姓名" disabled ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="邮箱" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="principalEmail">
              <a-input v-model="model.principalEmail" placeholder="请输入邮箱"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="座机" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="principalLandline" >
              <a-input v-model="model.principalLandline" placeholder="请输入座机"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="手机" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="principalMobile">
              <a-input v-model="model.principalMobile" placeholder="请输入手机"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="是否立即启用" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="status">
              <j-switch v-model="model.status" ></j-switch>
            </a-form-model-item>
          </a-col>

        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'

  export default {
    name: 'PreCommandForm',
    components: {
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      },
      factoryOptions: {
        type: Array
      }
    },
    data () {
      return {
        model:{
          status:'Y'
         },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
           name: [
              { required: true, message: '请输入防疫指挥部'},
              { min: 0, max: 100, message: '长度不超过 100 个字符', trigger: 'blur' }
           ],
          factoryIds: [
              { required: true, message: '请选择厂区'},
           ],
          principalId: [
            { required: true, message: '请选择系统账号'},
          ],
           employeeNo: [
              { required: true, message: '请输入负责人工号!'},
           ],
           principalAccount: [
              { required: true, message: '请输入系统账号!'},
           ],
           principalName: [
              { required: true, message: '请输入负责人姓名!'},
           ],
           principalEmail: [
              { required: true, message: '请输入邮箱!'},
              { min: 0, max: 100, message: '长度不超过 100 个字符', trigger: 'blur' },
             {validator: this.validateEmail},
           ],
           principalLandline: [
              { min: 0, max: 20, message: '长度不超过 20 个字符', trigger: 'blur' },
           ],
           principalMobile: [
              { required: true, message: '请输入手机!'},
             { validator: this.validateMobile }
           ],
           status: [
              { required: true, message: '请选择是否启用!'},
           ],
        },
        url: {
          add: "/prevent/command/add",
          edit: "/prevent/command/edit",
          queryById: "/prevent.datamaster/precommand/",
        },
        sysAccountOptions:[],
        isDisabled:false,
        factory:[],
      }
    },
    computed: {
      formDisabled(){
        return this.disabled
      },
    },
    created () {
      console.log('factoryOptions :',this.factoryOptions)
      this.getRoleByCode()
       //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
    },
    methods: {
      add () {
      //  this.edit(this.modelDefault);
      },
      edit (record) {
        this.isDisabled = true
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$set(this.model,'factoryIds',record.factoryIds)
      },
      submitForm () {
        console.log('model.factory : ',this.model.factory)
        console.log('factoryOptions : ',this.factoryOptions)
        
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            httpAction(httpurl,this.model,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },


      getRoleByCode(){
        getAction('/sys/role/roleByCode',{roleCode:'CommanderChief'}).then(res=>{
          if(res.success){
            console.log('res:',res)
            this.getRoleUser(res.result.id)
          }
        })
      },

      getRoleUser(roleId) {
        getAction('/sys/user/userRoleList',{roleId:roleId,pageNo:1,pageSize:99999}).then(res=>{
          if(res.success){
            this.sysAccountOptions = res.result.records.map((item,index,arr)=>{
              let c = {label:item.realname + " " + item.workNo, value: item.id+""}
              return c;
            })
          }
        })
      },

      handleAccoutChange(value)  {
        getAction('/sys/user/queryById',{id:value}).then(res=>{
          if(res.success){
            let result = res.result

            this.$set(this.model,'employeeNo',result.workNo)
            this.$set(this.model,'principalLandline',result.telephone)
            this.$set(this.model,'principalAccount',result.username)
            this.$set(this.model,'principalName',result.realname)
            this.$set(this.model,'principalEmail',result.email)
            this.$set(this.model,'principalMobile',result.phone)
            
          }
        })

      },

      validateMobile(rule, value, callback) {
        if (!value || new RegExp(/^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/).test(value)) {
          callback();
        } else {
          callback("您的手机号码格式不正确!");
        }
      },
      validateEmail(rule, value, callback){
        if(!value){
          callback();
        }else{
          if(new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/).test(value)){
            callback();
          }else{
            callback("请输入正确格式的邮箱!");
          }
        }
      },

      handleFactoryChange(value) {
        console.log('vale : ',value)
        this.model.factoryIds=`${value}`;
      },

    }
  }
</script>
<style lang="less" scoped>
  //禁用a-select 输入
  //https://juejin.cn/post/7081154012065562655
  .my_select_component {
  /deep/.ant-select-search__field {
    display: none !important;
  }
  /deep/ .ant-select-selection--multiple{
    cursor: pointer !important;
  }
}

</style>
